import React from 'react';



// import PROP from './constant_offline';
import PROP from './constant_online';

// const OnlineProp = React.lazy(() => import('./constant_online'));
// const OfflineProp = React.lazy(() => import('./constant_offline'));

// var DEMO1 = navigator.onLine?OnlineProp:OfflineProp;

// var DEMO = internet?(
//   fetch('//bhuvan-vec1.nrsc.gov.in',{mode:'no-cors'})
//       .then(()=>{
        
//         OnlineProp;
//       })
//       .catch(()=>{
       
//         OfflineProp;
//       })
// ):
// (OfflineProp);


var DEMO = {
  BASE_URL: PROP.BASE_URL,

  URL_FCGALLERY:PROP.URL_FCGALLERY,
  URL_STATEGALLERY:PROP.URL_STATEGALLERY,
  GALLERY_SUFFIX:PROP.GALLERY_SUFFIX,
  
  /* 
    API Section
  */
  API_BASEURL:PROP.API_BASEURL,
  API_SWHURL:PROP.API_SWHURL,
  KEYHEADER:PROP.KEYHEADER,
  
  //1. APIAlert
  APIALERT_KEY: PROP.APIALERT_KEY,
  URL_STATEALERT: PROP.URL_STATEALERT,
  URL_GJSONALERT: PROP.URL_GJSONALERT,
  URL_STATUSALERT: PROP.URL_STATUSALERT,

  URL_COUNTRYALERT: PROP.URL_COUNTRYALERT,
  URL_COUNTRYGJSONALERT: PROP.URL_COUNTRYGJSONALERT,
  URL_COUNTRYSTATUSALERT: PROP.URL_COUNTRYSTATUSALERT,
  
  //2. APIWeather
  APIWEATHER_KEY:PROP.APIWEATHER_KEY,
  APIDATA_KEY:PROP.APIDATA_KEY,

  URL_WEATHER:PROP.URL_WEATHER,
  URL_SLA:PROP.URL_SLA,
  URL_SLA_NRT:PROP.URL_SLA_NRT,
  URL_SWH:PROP.URL_SWH,
  URL_SWH_NRT:PROP.URL_SWH_NRT,
  URL_SWH_PRJ:PROP.URL_SWH_PRJ,

  URL_WRF:PROP.URL_WRF,
  URL_CMIP6:PROP.URL_CMIP6,

  //3. FreeAPIs
  URL_TEPHI: PROP.URL_TEPHI,
  MET_URL_PREFIX:PROP.MET_URL_PREFIX,
  
  PAGE_TITLE: PROP.PAGE_TITLE,
  MODEL_TITTLE:PROP.MODEL_TITTLE,
  // SIDEDRAWER_TITTLE: 'State Selection',

  /***** Types *****/
  TYPES: PROP.TYPES,
  DEFAULT_STATE:PROP.DEFAULT_STATE,
};

export default DEMO;